import { isRSAA, RSAA } from 'redux-api-middleware' // RSAA = '@@redux-api-middleware/RSAA'
import config from '../../config'

const { headerExceptions } = config

const logger = console

/**
 * Checks if an API is an exception for headers
 * @param {String} url API's url
 * @param {String} method Request method
 */
const isHeaderException = (url = '', method = '') => {
    const methodUpper = method.toUpperCase()
    return headerExceptions.some(({ method: excpMethod, url: excpUrl }) => new RegExp(excpUrl, 'i').test(url) && methodUpper === excpMethod.toUpperCase())
}

/**
 * Sets headers for API calls
 */
const APIHeaders = () => (next) => (action) => {
    let nextAction = action

    try {
        if (isRSAA(action)) {
            const {
                [RSAA]: { endpoint, headers, method },
            } = action

            if (!isHeaderException(endpoint, method)) {
                nextAction = {
                    ...action,
                    [RSAA]: {
                        ...action[RSAA],
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            ...headers,
                        },
                    },
                }
            }
        }
    } catch (error) {
        logger.error(error)
    }

    return next(nextAction)
}

export default APIHeaders
